import { InvitedBroker } from '../../../../models/InvitedBroker';
import {
  NOT_ACCEPTED_ACCEPTED_COPY,
  SortingDirectionValues,
} from 'models/Sort';

export type InvitedBrokerTable = Pick<
  InvitedBroker,
  'firstName' | 'email' | 'isBrokerAccepted'
>;

export type InvitedBrokerTableKeys = Array<keyof InvitedBrokerTable>;

export const TABLE_COLUMNS: InvitedBrokerTableKeys = [
  'firstName',
  'email',
  'isBrokerAccepted',
];

export const HEADING_TRANSLATIONS: Record<
  typeof TABLE_COLUMNS[number],
  string
> = {
  firstName: 'name',
  email: 'email',
  isBrokerAccepted: 'accepted',
};

export const ACCEPTED_FILTER_KEY = 'isBrokerAccepted';
export const NAME_FILTER_KEY = 'name';
export const EMAIL_FILTER_KEY = 'email';

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  firstName: 'sortName',
  email: 'email',
  isBrokerAccepted: 'isBrokerAccepted',
};

export const MULTI_SORT_DIRECTION_COPY: Record<
  string,
  SortingDirectionValues[string]
> = {
  [SORTING_VALUES.isBrokerAccepted]: NOT_ACCEPTED_ACCEPTED_COPY,
};

export const LOCKED_COLUMN: keyof InvitedBrokerTable = 'firstName';
